import { gql } from '@apollo/client';

export const CREATE_SMTP = gql`
mutation CreateSmtp($smtpInput: CreateSmtpInput!) {
  createSmtp(SmtpInput: $smtpInput) {
    smtp {
      userName
      password
      host
      port
      protocol
      senderEmail
      senderName
      ssl
    }
    imap {
      host
      password
      port
      protocol
      senderEmail
      senderName
      ssl
      userName
    }

  }
}
`


export const TEST_SMTP = gql`
mutation TestSmtpEmail($smtpInputType: SmtpInputType!) {
  testSmtpEmail(SmtpInputType: $smtpInputType)
}
`


export const REMOVE_SMTP_LINK = gql`
mutation Mutation {
  removeSmtp
}
`
